/**
 * useUpdateProfile — Layer-3 hook to update the current user's full name + email.
 *
 * Flow:
 * 1. PATCH /auth/me/ — persist the new full name and email.
 * 2. Invalidate authKeys.me() — AuthProvider's query refetches /me/ and context updates.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { authKeys } from "@/shared/lib/queryKeys";
import { updateMe } from "../api/authApi";

export interface UpdateProfileInput {
  fullName: string;
  email: string;
}

export function useUpdateProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateProfileInput) => updateMe(input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: authKeys.me() });
    },
  });
}
